import { useLogger, useSwanStyleKeys, useUserContext } from '@vp/ubik-context'
import { WixAnonymousPlansApp } from '../web/wix-anonymous-plans-page/WixAnonymousPlansApp'
import { StyleKeys } from '../web/common/swanKeys'
export const Fragment = (props: any) => {
  const logger = useLogger()
  const userContext = useUserContext()
  logger.log('Rendering fragment for a locale', userContext.locale)
  useSwanStyleKeys(StyleKeys)

  return <WixAnonymousPlansApp {...props} />
}
